import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import MapIcon from 'theme/icons/map.svg';
import MapPinIcon from 'theme/icons/map-pin.svg';

import SaveButton from 'components/modules/public/layout/controls/SaveButton';

import Title from '../Title';

import { AgremeentTypes, Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJobBlocksJobHeader: FunctionComponent<Props> = ({
    title,
    job,
    jobs,
}) => {
    const router = useRouter();
    return (
        <StyledComponent className="public-page-company-site-section-company-block-jobs">
            <Title title={title} />
            <div className="jobs-list">
                { Array.isArray(jobs) && jobs
                    .map(({ id, slug, companyLogo, name, salaryFromTo, companyName, jobAgreements, jobTime, jobCities, createSource }) => {
                        const agreement = jobAgreements.map(element => element.name)[0];
                        const jobCity = jobCities.map(element => ({
                            cityId: element.city.id,
                            city: element.city.name,
                            mapLink: element.googleMapLink,
                        }))[0];

                        const { cityId, city, mapLink } = jobCity || {};
                        const agreementAndTime = agreement ? (agreement === AgremeentTypes.JDG ? `${agreement}` : `${agreement}, ${jobTime?.name}`) : null;

                        return (
                            <div
                                key={id}
                                className="job-box"
                                onClick={() => router.push(withVariables(Routes.PublicJob, { slug }))}
                            >
                                <div className='job-logo-container'>
                                    <img
                                        className='job-logo'
                                        loading="lazy"
                                        src={createSource === 'cbop' ? '/images/jobs/e-praca-logo.svg' : companyLogo?.imageUrl || '/images/jobs/image-placeholder.svg'}
                                        alt=""
                                    />
                                </div>

                                <div className="job-details-desktop">
                                    <a
                                        className='job-header'
                                        href={withVariables(Routes.PublicJob, { slug })}
                                    >
                                        <p className="job-name">{name}</p>
                                        <div className="job-others">
                                            {salaryFromTo && (
                                                <p>
                                                    {salaryFromTo} pln
                                                </p>
                                            )}
                                            <p className='job-city'>
                                                {city}
                                            </p>
                                        </div>
                                    </a>
                                    <p className="job-company-name">
                                        {companyName}
                                    </p>
                                    <div className="job-company-info">
                                        <p className="job-company-info-details">{agreementAndTime}</p>
                                        <div className="job-buttons">
                                            <div className="button">
                                                <SaveButton
                                                    jobId={id}
                                                    cityId={cityId}
                                                />
                                            </div>
                                            { mapLink && (
                                                <a
                                                    className="button button-map"
                                                    href={mapLink}
                                                >
                                                    <img
                                                        loading='lazy'
                                                        src={MapIcon}
                                                        alt=""
                                                    />
                                                    <span>{job?.mapLabel}</span>
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="job-details-mobile">
                                    <a
                                        className='job-name'
                                        href={withVariables(Routes.PublicJob, { slug })}
                                    >
                                        {name}
                                    </a>
                                    <p className="job-company-name">
                                        {companyName}
                                    </p>
                                    {salaryFromTo && (
                                        <p className="job-salary">
                                            {salaryFromTo} pln
                                        </p>
                                    )}
                                    {jobCity && (
                                        <p className="job-city">
                                            <img
                                                src={MapPinIcon}
                                                alt=""
                                                loading='lazy'
                                            />
                                            {city}
                                        </p>
                                    )}

                                    <div className="job-save-button">
                                        <SaveButton
                                            jobId={id}
                                            cityId={cityId}
                                        />
                                    </div>

                                    <div className="job-map-icon">
                                        {mapLink && (
                                            <a
                                                className="button"
                                                href={mapLink}
                                            >
                                                <img
                                                    loading='lazy'
                                                    src={MapIcon}
                                                    alt=""
                                                />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobHeader;
